/* global axios */
import ApiClient from './ApiClient';

class DealReportsAPI extends ApiClient {
  constructor() {
    super('deal_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getSummary(params) {
    return axios.get(`${this.url}/summary`, { params });
  }

  getFunnel(params) {
    return axios.get(`${this.url}/funnel`, { params });
  }

  getEvolution(params) {
    return axios.get(`${this.url}/evolution`, { params });
  }

  getSalesReps(params) {
    return axios.get(`${this.url}/sales_reps`, { params });
  }

  getSourceDeals(params) {
    return axios.get(`${this.url}/source_deals`, { params });
  }

  getUtmValues() {
    return axios.get(`${this.url}/utm_values`);
  }

  getLossReasons(params) {
    return axios.get(`${this.url}/loss_reasons`, { params });
  }

  getActivity(params) {
    return axios.get(`${this.url}/activity`, { params });
  }

  getStalled(params) {
    return axios.get(`${this.url}/stalled`, { params });
  }

  // "Meu espaço": indicadores comerciais do próprio usuário logado, sem
  // exigir permissão de Relatórios (o backend sempre força o próprio id).
  getMySummary(params) {
    return axios.get(`${this.url}/my_summary`, { params });
  }

  getMyEvolution(params) {
    return axios.get(`${this.url}/my_evolution`, { params });
  }

  getMyStalled(params) {
    return axios.get(`${this.url}/my_stalled`, { params });
  }
}

export default new DealReportsAPI();
